import { LazyLoad } from '@petconsole/pure-fe-mui';

const BusBuilderAdmin = LazyLoad(() => import('./BusBuilderAdmin'));

export { BusBuilderAdmin };
